import {BrowserRouter as Router,Route,Switch} from 'react-router-dom'
import App from './App'
import Error from './404'
import ForgotPassword from './components/fortgotPassword/Index'
import ChangePassword from './components/changePassword/Index'
import React from 'react'

function Routes(){
  return (
    <Router>
      <Switch>
        <Route exact path="/login" component={App}/>
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/change-password" component={ChangePassword} />
        <Route component={Error} />
      </Switch>
    </Router>
  )
}

export default Routes